module.exports = __webpack_public_path__ + "static/media/swimming-normal-yeti.de947760.png";